import {CSSProperties} from 'styled-components';

export const CustomDatePickerStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
} as CSSProperties;
